import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const header: SxStyle = {
  borderBottom: (p) => `1px solid ${p.palette.grey[400]}`,
  px: (p) => p.spacing(2),
  py: (p) => p.spacing(2),
};

export const closeIcon: SxStyle = {
  cursor: 'pointer',
};

export const content: SxStyle = {
  p: (p) => p.spacing(2),
};

export const popover: SxStyle = {
  color: (p) => p.palette.common.white,
  backgroundColor: (p) => p.palette.common.black,
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
};

export const popoverIcon: SxStyle = {};

export const progress: SxStyle = {
  mr: 1,
};

export const costBox: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  mt: 2,
  gap: 1,
  p: (p) => p.spacing(1),
  color: (p) => p.palette.grey[700],
  fontWeight: (p) => p.typography.body2.fontSize,
  border: (p) => `1px solid ${p.palette.primary[200]}`,
  borderRadius: (p) => p.spacing(0.5),
};

export const footer: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  p: 1.5,
  gap: 1.5,
  borderTop: (p) => `1px solid ${p.palette.grey[400]}`,
};
